// src/utils/wakeServer.js

import axios from "axios";

const WAKE_URL =
  "https://b81hiave04.execute-api.us-east-1.amazonaws.com/prod/wake-server";

const BACKEND_URL = "https://api.ambitionjet.com";

const sleep = (ms) =>
  new Promise((resolve) => setTimeout(resolve, ms));

const wakeServer = async () => {

  try {
    // Check if backend already running
    await axios.get(BACKEND_URL);

    console.log("Backend already running");
    return true;

  } catch {

    console.log("Backend sleeping. Sending wake request...");

    try {
      await axios.post(WAKE_URL);

      // Wait for backend to become available
      for (let i = 0; i < 12; i++) {

        try {

          await axios.get(BACKEND_URL);

          console.log("Backend is ready");
          return true;

        } catch {

          console.log(
            `Waiting for backend... (${i + 1}/12)`
          );

          await sleep(5000);
        }
      }

      return false;

    } catch (err) {

      console.log("Wake request failed", err);
      return false;
    }
  }
};

export default wakeServer;